import axios from 'axios';

// const URL = 'http://localhost:4000'
const URL = process.env.REACT_APP_BASE_URL || 'https://roshi-chat.herokuapp.com'

axios.defaults.baseURL = URL;

export const GetHistory = async (id) => {
    const res = await axios.get(`/crm/payment/history/${id}`);
    return res.data;
}